/* Favoriten-Merkliste (Baustein G3): Besucher merken sich beim
   Stoebern je Komponente Quell-Uhren fuer die Nachfertigung.
   Ablage NUR im localStorage des Browsers (kein Konto, keine
   Server-Speicherung, kein DSGVO-Aufwand). Limit: maximal 5
   Favoriten JE BAUTEIL (Praezisierung Kostja 2026-08-16, z. B.
   fuenf Zifferblaetter aus fuenf verschiedenen Uhren), nicht 5
   gesamt. Genutzt von f24-watch-detail (Merken-Buttons) und
   f24-vorbestellen (Favoriten zuerst in der Uhr-Auswahl). */
(function () {
  var KEY = "f24_favoriten_v1";
  var LIMIT_JE_TYP = 5;

  function lesen() {
    var items = [];
    try {
      var d = JSON.parse(localStorage.getItem(KEY));
      if (d && d.v === 1 && Array.isArray(d.items)) items = d.items;
    } catch (e) { /* kaputter oder gesperrter Storage = keine Favoriten */ }
    // Je Typ auf das Limit kappen (auch Alt-Daten bleiben so gueltig)
    var jeTyp = {};
    return items.filter(function (x) {
      if (!x || typeof x.typ !== "string" || typeof x.uhr !== "string") return false;
      jeTyp[x.typ] = (jeTyp[x.typ] || 0) + 1;
      return jeTyp[x.typ] <= LIMIT_JE_TYP;
    });
  }

  function schreiben(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items }));
    } catch (e) { /* Storage voll/gesperrt: Anzeige bleibt konsistent, nur nicht dauerhaft */ }
    document.dispatchEvent(new CustomEvent("f24:favoriten", { detail: { items: items } }));
  }

  window.F24Favoriten = {
    LIMIT_JE_TYP: LIMIT_JE_TYP,
    list: lesen,
    count: function () { return lesen().length; },
    countTyp: function (typ) {
      return lesen().filter(function (x) { return x.typ === typ; }).length;
    },
    has: function (typ, uhr) {
      return lesen().some(function (x) { return x.typ === typ && x.uhr === uhr; });
    },
    /* Merken/Entfernen als ein Schalter. Rueckgabe: { ok, aktiv, limit, count } */
    toggle: function (typ, uhr) {
      var items = lesen();
      var idx = -1;
      var imTyp = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].typ === typ) {
          imTyp += 1;
          if (items[i].uhr === uhr) idx = i;
        }
      }
      if (idx >= 0) {
        items.splice(idx, 1);
        schreiben(items);
        return { ok: true, aktiv: false, limit: false, count: items.length };
      }
      if (imTyp >= LIMIT_JE_TYP) {
        return { ok: false, aktiv: false, limit: true, count: items.length };
      }
      items.push({ typ: typ, uhr: uhr });
      schreiben(items);
      return { ok: true, aktiv: true, limit: false, count: items.length };
    },
  };
})();
